import { render, staticRenderFns } from "./GoodsOfferAccept.vue?vue&type=template&id=08b6f9a6"
import script from "./GoodsOfferAccept.vue?vue&type=script&lang=ts"
export * from "./GoodsOfferAccept.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports